/* eslint-disable no-shadow */
import Typography from 'typography';
import CodePlugin from 'typography-plugin-code';
import Color from 'color';
import gray from './gray';
import colors from './colors';

const system = [
  '-apple-system',
  'BlinkMacSystemFont',
  'Segoe UI',
  'Helvetica Neue',
  'Arial',
  'sans-serif',
];

const monospace = [
  'SFMono-Regular',
  'Menlo',
  'Monaco',
  'Consolas',
  'Liberation Mono',
  'Courier New',
  'monospace',
];

const options = {
  baseFontSize: '18px',
  baseLineHeight: 1.6666,
  headerLineHeight: 1.075,
  headerFontFamily: ['League Spartan', ...system],
  bodyFontFamily: ['Source Sans Pro', ...system],
  monospaceFontFamily: ['Space Mono', ...monospace],
  headerColor: gray(28, 'cool'),
  bodyColor: gray(8, 'cool'),
  headerWeight: 600,
  bodyWeight: 400,
  boldWeight: 700,
  blockMarginBottom: 1,
  scaleRatio: 2,
  overlayFontSize: '24px',
  plugins: [new CodePlugin()],
  overrideStyles: ({ rhythm, scale, adjustFontSizeTo }, options) => ({
    '::selection': {
      color: colors.ui.bright,
      backgroundColor: Color(colors.pixelmoxie)
        .hsl()
        .alpha(0.8)
        .string(),
    },
    '::-moz-selection': {
      color: colors.ui.bright,
      backgroundColor: Color(colors.pixelmoxie)
        .hsl()
        .alpha(0.8)
        .string(),
    },
    'tt, code, code[class*="language-"], pre[class*="language-"]': {
      ...adjustFontSizeTo('16px'),
      fontFamily: options.monospaceFontFamily.join(','),
      // Disable ligatures as they look funny w/ Space Mono as code.
      fontVariant: 'none',
      WebkitFontFeatureSettings: '"clig" 0, "calt" 0',
      fontFeatureSettings: '"clig" 0, "calt" 0',
      paddingTop: '0.1em',
      paddingBottom: '0.1em',
      borderRadius: '3px',
      boxShadow: `inset 0 0 0 1px ${gray(86, 'cool')}`,
    },
    ':not(pre) > code[class*="language-"]': {
      borderRadius: '3px !important',
    },
    '.gatsby-resp-image-figcaption': {
      ...scale(-1 / 5),
      lineHeight: 1.3,
      paddingTop: rhythm(3 / 8),
      marginBottom: rhythm(options.blockMarginBottom * 2),
      display: 'block',
      color: gray(32, 'cool'),
      textAlign: 'center',
      fontStyle: 'normal',
      position: 'relative',
    },
    '.gatsby-resp-iframe-wrapper': {
      marginBottom: rhythm(options.blockMarginBottom),
    },
    '.gatsby-highlight': {
      marginBottom: rhythm(options.blockMarginBottom),
    },
    '.medium-zoom-overlay, .medium-zoom-image--open': {
      zIndex: 900,
    },
  }),
};

const typography = new Typography(options);

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js